import React from "react";
import { AgGridReact } from "ag-grid-react";

const MyVendor = ({
  columnDefs,
  rowData,
  getRowHeight,
  defaultColDef,
  frameworkComponents,
  modules,
  overlayNoRowsTemplate,
}) => {
  return (
    <div className="ag-theme-balham myVendorTable">
      <AgGridReact
        columnDefs={columnDefs}
        rowData={rowData}
        getRowHeight={getRowHeight}
        defaultColDef={defaultColDef}
        frameworkComponents={frameworkComponents}
        paginationPageSize="20"
        pagination={true}
        modules={modules}
        overlayNoRowsTemplate={overlayNoRowsTemplate}
      />
    </div>
  );
};
export default MyVendor;
